import React, { useEffect, useState, useMemo } from "react";
import { withTranslation } from "react-i18next";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";
import ApprovedApplication from "./ApprovedApplication";
import ReceivedApplication from "./ReceivedApplication";
import ReceivedNotReviewed from "./ReceivedNotReviewed";
import DeniedApplication from "./DeniedApplication";
import WithdrawnApplication from "./WithdrawnApplication";
import PendingInformation from "./PendingInformation";
import NoInformationStatus from "./NoInformationStatus";
import { useLocation } from "react-router-dom";

const ApplicationStatusView = ({ t, i18n }) => {
  const location = useLocation();
  const chequeStatus = location?.state?.chequeStatus;
  const [backPath, setBackPath] = useState(null);
  const { search } = useLocation();
  //   const url = new URLSearchParams(search);

  // Get the value of the 'response' parameter
  const response = useMemo(() => {
    return JSON.parse(
      new URLSearchParams(location.search).get("response") || false
    );
  }, [location.search]);


  useEffect(() => {
    // if (!disableGApush) {
    try {
      addToGoogleDataLayer(
        "application-status-check",
        "HARP Application",
        i18n.language
      );
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
    setBackPath(t("routes.check_status"));
  }, [i18n.language, t]);

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <BackAnchor backPath={backPath} />
            <div className="row">
              {response === 153 && (
                <div className="col-xs-12 col-md-10">
                  <ApprovedApplication chequeStatus={chequeStatus} />
                </div>
              )}
              {(response === 6021 ||
                response === 22 ||
                response === 46 ||
                response === 6023 ||
                response === 6020) && (
                  <div className="col-xs-12 col-md-10">
                    <ReceivedApplication />
                  </div>
                )}
              {response === 6024 && (
                <div className="col-xs-12 col-md-10">
                  <ReceivedNotReviewed />
                </div>
              )}
              {(response === 16 ||
                response === 131) && (
                  <div className="col-xs-12 col-md-10">
                    <DeniedApplication />
                  </div>
                )}
              {response === 4 && (
                <div className="col-xs-12 col-md-10">
                  <WithdrawnApplication />
                </div>
              )}
              {response === 115 && (
                <div className="col-xs-12 col-md-10">
                  <PendingInformation />
                </div>
              )}
              {(response === null ||
                response === "" ||
                response === undefined ||
                !response) && (
                  <div className="col-xs-12 col-md-10">
                    <NoInformationStatus />
                  </div>
                )}
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(ApplicationStatusView);
